<template>
  <v-dialog v-model="show" persistent max-width="350">
    <v-card>
      <v-toolbar class="ps-3" color="error">{{
        title + " (" + $t("config.delete") + ")"
      }}</v-toolbar>
      <v-card-text>{{ $t("config.delete") + text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="flat" color="error" @click="deleteFunction()">
          {{ $t("config.delete") }}</v-btn
        >
        <v-btn
          variant="outlined"
          color="error"
          @click="show = false"
          >{{ $t("config.cancel") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    deleteFunction: Function,
    text: String,
    title: String,
    modelValue: Boolean,
  },
  name: "ConfigRoundDeleteDialog",
  computed: {
    show: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
};
</script>
